module.exports = "/img/root-chat.9a1ea549.png";